app.factory('designLineService', function(
    $rootScope,
    $http,
    $cookies
) {
    return {
        designLines: [],
        fetchDesignLines: function(configurationId) {
            return $http.get('/api/designwebben/designlines/' + configurationId)
                .then(function(res) {
                    this.designLines = res.data
                }.bind(this))
        },
        getDesignLineById: function(designLineId) {
            return getWhereId(this.designLines, designLineId)
        }
    }
})
